module.exports = __webpack_public_path__ + "img/D201803_1.d9356905.jpg";